@if (healthBookings) {
  <div nz-row>
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24" class="cardList">
      <div nzSpan="24" class="header-medical">
        <div class="header-medical-container">
          <div class="header-medical-left">
            <span>
              <img src="/public/assets/images/heart.svg" alt="Logo" class="desktop" />
              <img src="/public/assets/images/hand-arm-heart.svg" alt="left circle" class="mobile" />
            </span>
            @if (isUserManagementAble) {
              <span class="subtitle" style="font-size: 16px">{{ 'medicalConsultations.newConsultationMessage' | translate }}</span>
            } @else {
              <span class="subtitle" style="font-size: 16px">{{ 'medicalConsultations.newConsultationMessageAlone' | translate }}</span>
            }
          </div>

          <div class="header-medical-right desktop">
            <button
              nz-button
              nzAccessible
              nzType="default"
              nzShape="circle"
              (click)="prevPage()"
              [disabled]="currentPage === 0"
              [ngClass]="{ trueButton: currentPage !== 0, falseButton: currentPage === 0 }"
              aria-label="Vai alla pagina precedente"
            >
              <img src="/public/assets/images/left-circle.svg" alt="left circle" aria-hidden="true" />
            </button>

            <span style="color: rgb(7, 50, 168)">{{ currentPage + 1 }}</span>
            <span style="margin: 0 8px">di</span>
            <span style="top: 3px; position: relative">{{ totalPages }}</span>

            <button
              nz-button
              nzAccessible
              nzType="default"
              nzShape="circle"
              (click)="nextPage()"
              [disabled]="currentPage >= totalPages - 1"
              [ngClass]="{ trueButton: currentPage < totalPages - 1, falseButton: currentPage >= totalPages - 1 }"
              aria-label="Vai alla pagina successiva"
            >
              <img src="/public/assets/images/right-circle.svg" alt="right circle" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>

      <div class="table-row">
        <div nz-row nzJustify="center" nzGutter="16" style="display: flex; justify-content: space-around">
          @for (data of paginatedCards; track data) {
            <div nz-col nzXs="24" nzSm="12" nzMd="8">
              @if (data.service || data.service === '') {
                <nz-card class="card-style">
                  <div class="card-head-left">
                    <img src="{{ data?.icon }}" alt="Logo" />
                    @if (notificationMap[data.service]; as notification) {
                      <span class="notification-counter">
                        <span class="current">{{ notification?.current }}</span>
                        <span class="separator">/</span>
                        <span class="limit">{{ notification?.limit }}</span>
                      </span>
                    }
                  </div>
                  <div class="card-title">
                    <span>{{ data?.title }}</span>
                  </div>
                  <div class="card-description">
                    <span class="title">{{ data?.description }}</span>
                  </div>
                  <ds-button
                    class="button-card"
                    [routerLink]="['/medical-consultations', data?.buttonRoute]"
                    [text]="data?.buttonText"
                    [width]="'small'"
                    [iconRight]="'/public/assets/images/icon-right-white.svg'"
                    style="display: block; justify-items: center"
                  >
                  </ds-button>
                </nz-card>
              }
            </div>
          }
        </div>
      </div>

      <div class="header-medical-right mobile" style="margin-top: 16px">
        <button
          nz-button
          nzAccessible
          nzType="default"
          nzShape="circle"
          (click)="prevPage()"
          [disabled]="currentPage === 0"
          [ngClass]="{ trueButton: currentPage !== 0, falseButton: currentPage === 0 }"
          aria-label="Vai alla pagina precedente"
        >
          <img src="/public/assets/images/left-circle.svg" alt="left circle" aria-hidden="true" />
        </button>

        <span style="color: rgb(7, 50, 168)">{{ currentPage + 1 }}</span>
        <span style="margin: 0 8px">di</span>
        <span style="top: 3px; position: relative">{{ totalPages }}</span>

        <button
          nz-button
          nzAccessible
          nzType="default"
          nzShape="circle"
          (click)="nextPage()"
          [disabled]="currentPage >= totalPages - 1"
          [ngClass]="{ trueButton: currentPage < totalPages - 1, falseButton: currentPage >= totalPages - 1 }"
          aria-label="Vai alla pagina successiva"
        >
          <img src="/public/assets/images/right-circle.svg" alt="right circle" aria-hidden="true" />
        </button>
      </div>
    </div>
  </div>
}
